import React from 'react';
import { Card as AntCard, Avatar as AntAvatar, Image as AntImage } from 'antd';
import { MetaData } from 'src/slices/metadata';
import { useTranslation } from 'react-i18next';
/*  
 * ​AntDesign's "Tag" component is being overriden and wrapped in a custom component here. 
 *
 * ​When calling "CustomTag" from somewhere in the code, instead of calling antdesign's "Tag", you're calling this component. 
 ​*/
interface ArticleInformationProps {
  loading: boolean;
  metaDatas: MetaData;
}

const { Meta } = AntCard;

export const ArticleInformation: React.VFC<
  ArticleInformationProps & React.HTMLAttributes<HTMLDivElement>
> = (props) => {
  const { t } = useTranslation();

  return (
    <AntCard
      style={{ marginBottom: 15 }}
      loading={props.loading}
      cover={!props.loading && <AntImage src={props.metaDatas?.image} />}
    >
      <Meta
        title={props.metaDatas?.title}
        description={
          <div>
            <p>{props.metaDatas?.description}</p>
            <a href={props.metaDatas?.url}>{props.metaDatas?.url}</a>
            <p>
              {props.metaDatas?.author
                ? `${t('addArticleTranslation.authorBy')} ${
                    props.metaDatas.author
                  }`
                : null}
            </p>
            <p>
              {props.metaDatas?.date
                ? new Date(props.metaDatas?.date).toISOString().split('T')[0]
                : Date.now()}
            </p>
          </div>
        }
        avatar={<AntAvatar src={props.metaDatas?.logo} />}
      />
    </AntCard>
  );
};
